import { Layout } from "@/components/layout/Layout";
import { SEOHead } from "@/components/seo/SEOHead";
import { HeroSection } from "@/components/home/HeroSection";
import { WhyMitraSection } from "@/components/home/WhyMitraSection";
import { FounderImpactSection } from "@/components/home/FounderImpactSection";
import { EnterpriseReadySection } from "@/components/home/EnterpriseReadySection";
import { WhatWeSolveSection } from "@/components/home/WhatWeSolveSection";
import { ServicesSection } from "@/components/home/ServicesSection";
import { HowWeWorkPreviewSection } from "@/components/home/HowWeWorkPreviewSection";
import { SelectivePartnershipSection } from "@/components/home/SelectivePartnershipSection";
import { TestimonialsSection } from "@/components/home/TestimonialsSection";
import { WhoWeHelpSection } from "@/components/home/WhoWeHelpSection";
import { HomeFAQSection } from "@/components/home/HomeFAQSection";
import { CTABand } from "@/components/ui/CTABand";

// Homepage structured data, FAQPage schema is emitted by HomeFAQSection
const homepageStructuredData = [
  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "@id": "https://foundermitra.com/#webpage",
    "url": "https://foundermitra.com/",
    "name": "Founder Mitra | Strategic Tech & AI Advisory for Startup Founders",
    "description": "FounderMitra is a founder-first strategic technology and AI advisory partner. We help founder-led businesses make sharper decisions across product, architecture, AI adoption, workflow redesign and execution.",
    "isPartOf": {
      "@id": "https://foundermitra.com/#website"
    },
    "about": {
      "@id": "https://foundermitra.com/#organization"
    },
    "primaryImageOfPage": {
      "@type": "ImageObject",
      "url": "https://foundermitra.com/og-image.png"
    },
    "breadcrumb": {
      "@type": "BreadcrumbList",
      "itemListElement": [{
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://foundermitra.com/"
      }]
    },
    "speakable": {
      "@type": "SpeakableSpecification",
      "cssSelector": ["h1", ".hero-description"]
    },
    "mainEntity": {
      "@type": "ProfessionalService",
      "name": "Founder Mitra",
      "description": "Strategic technology and AI advisory for startup founders in India and globally",
      "priceRange": "$$",
      "areaServed": ["India", "Global"],
      "serviceType": ["Strategic Technology Advisory", "AI Advisory and Enablement", "Investor Technology Readiness", "Product Discovery and MVP Strategy", "Executive Dashboards and Decision Intelligence"]
    }
  }
];

export default function Index() {
  return (
    <Layout>
      <SEOHead
        title="FounderMitra | Strategic Technology & AI Advisory"
        description="FounderMitra helps founder-led businesses make sharper decisions across technology strategy, AI adoption, product architecture, workflow redesign and execution."
        canonical="/"
        keywords="FounderMitra, strategic technology advisory, founder-side technology advisor, AI advisory, technology leadership advisory, product and platform architecture, investor readiness, execution governance"
        structuredData={homepageStructuredData}
      />
      <HeroSection />
      <FounderImpactSection />
      <WhyMitraSection />
      <WhatWeSolveSection />
      <ServicesSection />
      <HowWeWorkPreviewSection />
      <EnterpriseReadySection />
      <SelectivePartnershipSection />
      <WhoWeHelpSection />
      <TestimonialsSection />
      <HomeFAQSection />
      <CTABand />
    </Layout>
  );
}
